// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor_form_field {
  width: 100%;
}

.vendor_form_field input {
  font-size: 12px !important;
}

.agents_fontsize {
  font-size: 12px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

::ng-deep .filelist_chip.mat-chip {
  max-width: 28% !important;
}

.vendor_form_field {
  width: 100%;
}

.vendor_form_field input {
  font-size: 12px !important;
}

.file-input {
  display: none;
}

.text-ellipsis {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::ng-deep.saveVendormodal .modal-dialog {
  max-width: 58% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.saveVendormodal {
  top: 16% !important;
}

::ng-deep.vendor_form_field .mat-form-field-infix {
  padding: 0% !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

::ng-deep.vendor_chiplist .mat-form-field-infix {
  padding: 0 !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

::ng-deep.vendor_chiplist .mat-chip.mat-standard-chip {
  background-color: #17a0b4 !important;
  color: rgb(255, 255, 255) !important;
}

::ng-deep.vendor_chiplist .mat-chip.mat-standard-chip .mat-chip-remove {
  color: rgb(255, 255, 255) !important;
  opacity: 1 !important;
}

.vendor_cast {
  font-size: 11px !important;
  height: 30px !important;
}

.vendorconnectivity_chiplist {
  width: 100%;
}

::ng-deep.vendorconnectivity_chiplist .mat-standard-chip {
  font-size: 11px;
  margin: 0px;
  height: 23px;
  padding-inline: 5px;
  min-height: unset;
  margin-right: 7px !important;
}

::ng-deep.vendor_chiplist .mat-standard-chip {
  font-size: 11px;
  margin: 0px;
  height: 23px;
  padding-inline: 5px;
  min-height: unset;
  margin-right: 7px !important;
}

::ng-deep.vendorconnectivity_chiplist .mat-form-field-wrapper {
  padding: 0px !important;
}

::ng-deep.vendorconnectivity_chiplist .mat-form-field-infix {
  padding: 4px !important;
  padding-bottom: 6px !important;
  padding-top: 0px !important;
  padding-left: 1% !important;
}

::ng-deep.vendorconnectivity_chiplist .mat-chip.mat-standard-chip {
  background-color: #17a0b4 !important;
  color: rgb(255, 255, 255) !important;
}

::ng-deep.vendorconnectivity_chiplist .mat-chip.mat-standard-chip .mat-chip-remove {
  color: rgb(255, 255, 255) !important;
  opacity: 1 !important;
}

::ng-deep.vendor_form_field .mat-form-field-empty.mat-form-field-label {
  display: block;
  position: relative !important;
  top: 7px !important;
}

::ng-deep.vendor_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.59375em) scale(0.75);
  width: 133.33333%;
  position: relative;
  top: 13px !important;
}

.search_control_vendor {
  height: 30px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  border-radius: 5px;
}

.label_style {
  display: block;
  margin-block: 1%;
  font-size: 12px !important;
}

.font_text {
  font-size: 12px !important !important;
}

::ng-deep.agmatoutlinestyles.mat-mdc-form-field {
  width: 100%;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 6px !important;
  height: 31px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 30px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 11px !important;
  padding-bottom: 24px;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-input-element {
  position: relative;
  font-size: 12px !important;
  bottom: 8px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  bottom: 11px !important;
}

::ng-deep.rolematselect {
  bottom: 5px !important;
  position: relative !important;
}

::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper {
  background-color: white !important;
  height: 35px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 0px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 11px !important;
  width: 165px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
  background-color: #17a0b4 !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mat-mdc-chip-action {
  padding-left: 5px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mat-mdc-chip-action .mdc-evolution-chip__text-label {
  font-size: 12px !important;
  color: white !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mat-mdc-chip-remove {
  color: white !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper {
  background-color: white !important;
  height: 35px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mdc-line-ripple {
  display: none !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-focus-overlay {
  background-color: white !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  display: flex !important;
  padding-top: 0px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-input-element {
  font-size: 12px !important;
  width: 150px !important;
  flex: 1 0 150px !important;
  margin-left: 4px;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip {
  height: 24px !important;
  float: left !important;
  margin-inline: 1px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix .mat-mdc-chip .mdc-evolution-chip__text-label {
  font-size: 12px !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-focused .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
::ng-deep.venmatchip .mat-mdc-form-field .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/vendor/Savevendor/savevendor.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,WAAA;AAAJ;;AAGE;EACE,0BAAA;AAAJ;;AAEE;EACE,0BCRO;ADSX;;AACE;EACE,sBAAA;AAEJ;;AACE;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAEJ;;AAAE;EACI,yBAAA;AAGN;;AADE;EACE,WAAA;AAIJ;;AADE;EACE,0BAAA;AAIJ;;AAFE;EACE,aAAA;AAKJ;;AAHE;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAMJ;;AAJA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAOF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;AAQF;;AANA;EACE,qBAAA;EACA,8BAAA;EACA,2BAAA;AASF;;AAPA;EACE,oCAAA;EACA,oCAAA;AAUF;;AARA;EACE,oCAAA;EACA,qBAAA;AAWF;;AATA;EACE,0BAAA;EACA,uBAAA;AAYF;;AAVA;EACE,WAAA;AAaF;;AAXA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;AAcF;;AAZA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,4BAAA;AAeF;;AAbA;EACE,uBAAA;AAgBF;;AAdA;EACE,uBAAA;EACA,8BAAA;EACA,2BAAA;EACA,2BAAA;AAiBF;;AAfA;EACE,oCAAA;EACA,oCAAA;AAkBF;;AAhBA;EACE,oCAAA;EACA,qBAAA;AAmBF;;AAfA;EACE,cAAA;EACA,6BAAA;EACA,mBAAA;AAkBF;;AAfA;EACE,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAkBF;;AAhBA;EACE,uBCvHW;EDwHX,0BC3HS;ED4HT,oDAAA;EACA,kBAAA;AAmBF;;AAjBA;EACE,cAAA;EACA,gBAAA;EACA,0BClIS;ADsJX;;AAlBA;EACE,qCAAA;AAqBF;;AAlBA;EACE,WAAA;AAqBF;AApBE;EACE,uBAAA;EACA,uBAAA;AAsBJ;AAnBI;EACE,uBAAA;AAqBN;AApBM;EACI,0BAAA;EACA,oBAAA;AAsBV;AApBM;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;AAsBR;AApBM;EACE,uBAAA;AAsBR;;AAjBA;EACE,sBAAA;EACA,6BAAA;AAoBF;;AAjBE;EACE,kCAAA;EACA,uBAAA;AAoBJ;AAnBI;EACE,wBAAA;AAqBN;AAnBI;EACE,kCAAA;AAqBN;AAnBI;EACE,wBAAA;EACA,2BAAA;AAqBN;AApBM;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAsBR;AApBM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,oCAAA;AAsBR;AArBQ;EACE,4BAAA;AAuBV;AAtBQ;EACE,0BAAA;EACA,uBAAA;AAwBV;AArBM;EACE,uBAAA;AAuBR;AAjBI;EACA,kCAAA;EACA,uBAAA;AAmBJ;AAlBI;EACE,wBAAA;AAoBN;AAlBI;EACE,kCAAA;AAoBN;AAlBI;EACE,wBAAA;EACA,2BAAA;AAoBN;AAnBM;EACE,0BAAA;EACA,uBAAA;EACA,0BAAA;EACA,gBAAA;AAqBR;AAnBM;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;AAqBR;AApBQ;EACE,0BAAA;AAsBV;AAjBI;EACE,wBAAA;AAmBN;AAhBE;EACE,wBAAA;AAkBJ","sourcesContent":["@import \"../../../variables.scss\";\r\n.vendor_form_field{\r\n    width: 100%;\r\n\r\n  }\r\n  .vendor_form_field input{\r\n    font-size: 12px!important;\r\n  }\r\n  .agents_fontsize{\r\n    font-size: $fontsize;\r\n  }\r\n  ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n    height: 0px !important;\r\n  }\r\n\r\n  ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n    top: 0;\r\n    height: 0px !important;\r\n    overflow: hidden;\r\n  }\r\n  ::ng-deep .filelist_chip.mat-chip{\r\n      max-width: 28%!important;\r\n  }\r\n  .vendor_form_field{\r\n    width: 100%;\r\n\r\n  }\r\n  .vendor_form_field input{\r\n    font-size: 12px!important;\r\n  }\r\n  .file-input {\r\n    display: none;\r\n  }\r\n  .text-ellipsis{\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n::ng-deep.saveVendormodal .modal-dialog {\r\n  max-width: 58%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.saveVendormodal{\r\n  top: 16%!important;\r\n}\r\n\r\n::ng-deep.vendor_form_field .mat-form-field-infix{\r\n  padding: 0%!important;\r\n  padding-bottom: 7px!important;\r\n  padding-top: 2px!important;\r\n}\r\n::ng-deep.vendor_chiplist .mat-form-field-infix{\r\n  padding: 0!important;\r\n  padding-bottom: 7px!important;\r\n  padding-top: 2px!important;\r\n}\r\n::ng-deep.vendor_chiplist .mat-chip.mat-standard-chip {\r\n  background-color: #17a0b4!important;\r\n  color: rgb(255 255 255)!important;\r\n}\r\n::ng-deep.vendor_chiplist .mat-chip.mat-standard-chip .mat-chip-remove {\r\n  color: rgb(255 255 255)!important;\r\n  opacity: 1!important;\r\n}\r\n.vendor_cast{\r\n  font-size:11px !important;\r\n  height: 30px!important;\r\n}\r\n.vendorconnectivity_chiplist{\r\n  width: 100%;\r\n}\r\n::ng-deep.vendorconnectivity_chiplist .mat-standard-chip{\r\n  font-size: 11px;\r\n  margin: 0px;\r\n  height: 23px;\r\n  padding-inline: 5px;\r\n  min-height:unset;\r\n  margin-right: 7px !important;\r\n}\r\n::ng-deep.vendor_chiplist .mat-standard-chip{\r\n  font-size: 11px;\r\n  margin: 0px;\r\n  height: 23px;\r\n  padding-inline: 5px;\r\n  min-height:unset;\r\n  margin-right: 7px !important;\r\n}\r\n::ng-deep.vendorconnectivity_chiplist .mat-form-field-wrapper{\r\n  padding: 0px !important;\r\n}\r\n::ng-deep.vendorconnectivity_chiplist  .mat-form-field-infix{\r\n  padding: 4px !important;\r\n  padding-bottom: 6px !important;\r\n  padding-top: 0px !important;\r\n  padding-left: 1% !important;\r\n}\r\n::ng-deep.vendorconnectivity_chiplist .mat-chip.mat-standard-chip {\r\n  background-color: #17a0b4!important;\r\n  color: rgb(255 255 255)!important;\r\n}\r\n::ng-deep.vendorconnectivity_chiplist .mat-chip.mat-standard-chip .mat-chip-remove {\r\n  color: rgb(255 255 255)!important;\r\n  opacity: 1!important;\r\n}\r\n\r\n\r\n::ng-deep.vendor_form_field .mat-form-field-empty.mat-form-field-label {\r\n  display: block;\r\n  position: relative !important;\r\n  top: 7px !important;\r\n}\r\n\r\n::ng-deep.vendor_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n  transform: translateY(-1.59375em) scale(.75);\r\n  width: 133.33333%;\r\n  position: relative;\r\n  top: 13px !important;\r\n}\r\n.search_control_vendor{\r\n  height:$inputHeight;\r\n  font-size:$fontsize;\r\n  box-shadow:0 2px 5px rgb(0 0 0 / 25%) !important;\r\n  border-radius: 5px;\r\n}\r\n.label_style{\r\n  display: block;\r\n  margin-block: 1%;\r\n  font-size: $fontsize;\r\n}\r\n.font_text{\r\n  font-size:$fontsize !important;\r\n}\r\n\r\n::ng-deep.agmatoutlinestyles.mat-mdc-form-field{ \r\n  width: 100%;\r\n  .mdc-text-field--outlined {\r\n    padding: 6px !important;\r\n    height: 31px !important;\r\n  }\r\n  .mat-mdc-text-field-wrapper{\r\n    .mat-mdc-form-field-flex {\r\n      height: 30px !important;\r\n      .mdc-notched-outline .mdc-floating-label{\r\n          font-size: 11px !important;\r\n          padding-bottom: 24px;\r\n      }\r\n      .mat-mdc-input-element{\r\n        position: relative;\r\n        font-size: 12px !important;\r\n        bottom: 8px !important;\r\n      }\r\n      .mat-mdc-form-field-infix{\r\n        bottom: 11px !important;\r\n      }\r\n    }\r\n }\r\n}\r\n::ng-deep.rolematselect{\r\n  bottom: 5px !important;\r\n  position: relative !important;\r\n}\r\n::ng-deep.venmatchip .mat-mdc-form-field{\r\n  .mat-mdc-text-field-wrapper{\r\n    background-color: white !important;\r\n    height: 35px !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: white !important;\r\n    }\r\n    .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n      display: flex !important;\r\n      padding-top: 0px  !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 11px !important;\r\n        width: 165px !important;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        background-color: #17a0b4 !important;\r\n        .mat-mdc-chip-action{\r\n          padding-left: 5px  !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n          color: white !important;\r\n        }\r\n      }\r\n      .mat-mdc-chip-remove{\r\n        color: white !important;\r\n      }\r\n      }\r\n    }\r\n  }\r\n  .mat-focused {\r\n    .mat-mdc-text-field-wrapper{\r\n    background-color: white !important;\r\n    height: 35px !important;\r\n    .mdc-line-ripple{\r\n      display: none !important;\r\n    }\r\n    .mat-mdc-form-field-focus-overlay{\r\n      background-color: white !important;\r\n    }\r\n    .mat-mdc-form-field-flex .mat-mdc-form-field-infix{\r\n      display: flex !important;\r\n      padding-top: 0px  !important;\r\n      .mat-mdc-input-element{\r\n        font-size: 12px !important;\r\n        width: 150px !important;\r\n        flex: 1 0 150px !important;\r\n        margin-left: 4px;\r\n      }\r\n      .mat-mdc-chip{\r\n        height: 24px !important;\r\n        float: left !important;\r\n        margin-inline: 1px !important;\r\n        .mdc-evolution-chip__text-label{\r\n          font-size: 12px !important;\r\n        }\r\n      }\r\n    }\r\n    }\r\n    .mat-mdc-form-field-subscript-wrapper{\r\n      display: none !important;\r\n    }\r\n  }\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n}\r\n","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
